import script from "./ValueWithLabel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ValueWithLabel.vue?vue&type=script&lang=ts&setup=true"

import "./ValueWithLabel.vue?vue&type=style&index=0&id=62b37eb4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62b37eb4"]])

export default __exports__